import type { SelectTable, Table } from "@models/table";
import { systemTablesApi } from "@features/tables/api/systemTables.api";
import { accountsApi } from "@features/tickets/public";
import { documentsSettingsApi } from "@features/documents/api/documentsSettings.api";
import { useCallback } from "react";
import { Account } from "@models/account";
import { DocumentSettings } from "@models/document-settings";

import { PaymentTable, StatusTable } from "@models/types";

const paymentTableData: PaymentTable[] = [
    {
        "index": 0,
        "name": "שיקים"
    },
    {
        "index": 1,
        "name": "מזומן"
    },
    {
        "index": 2,
        "name": "אשראי"
    },
    {
        "index": 3,
        "name": "העברות"
    }
];


const statusTableData: StatusTable[] = [
    {
        "index": 0,
        "name": "פתוח"
    },
    {
        "index": 1,
        "name": "סגור"
    },
    {
        "index": 2,
        "name": "סגור חלקית"
    },
];


export function useSelectTableByNumber() {
  const [triggerSys] = systemTablesApi.useLazyGetSystemTableOptionsQuery();
  const [triggerAccts] = accountsApi.useLazyGetAccountsByTypeQuery();
  const [triggerDocs] = documentsSettingsApi.useLazyGetDocumentsSettingsQuery();

  const getData = useCallback(
    async (tableNumber: number): Promise<SelectTable[]> => {
      if (tableNumber === 19) return statusTableData;
      if (tableNumber === 20) return paymentTableData;

      if (tableNumber >= 1 && tableNumber <= 6) {
        return convertSystemTableToSelectTable(await triggerSys(tableNumber, true).unwrap());
      }

      if (tableNumber === 12)
        return convertAccountToSelectTable(await triggerAccts("הכנסה", true).unwrap());
      if (tableNumber === 13)
        return convertAccountToSelectTable(await triggerAccts("הוצאה", true).unwrap());
      if (tableNumber === 14)
        return convertAccountToSelectTable(await triggerAccts("בנק", true).unwrap());
      if (tableNumber === 15)
        return convertAccountToSelectTable(await triggerAccts("קופה", true).unwrap());

      if (tableNumber === 18) {
        return convertDocumentsSettingsToSelectTable(await triggerDocs(undefined, true).unwrap());
      }

      return [];
    },
    [triggerSys, triggerAccts, triggerDocs],
  );

  return [getData] as const;
}

function convertSystemTableToSelectTable(table: Table[]): SelectTable[] {
  return table.map((option) => ({
    index: option.index,
    name: option.name,
  }));
}

function convertAccountToSelectTable(accounts: Account[]): SelectTable[] {
  return accounts.map((account) => ({
    index: account.card_number,
    name: account.account_name,
  }));
}

function convertDocumentsSettingsToSelectTable(docsSettings: DocumentSettings[]): SelectTable[] {
  return docsSettings.map((settings) => ({
    index: settings.id,
    name: settings.name,
  }));
}
